<template>
  <div justify-left class="contact-box">
    <b>{{name}}</b><br/>
    <v-icon small color="#e7511e" class="pr-4">phone</v-icon>{{phone}} <br/>
    <v-icon small color="#e7511e" class="pr-4">email</v-icon><a class="white--text" :href="`mailto:${email}`">{{email}}</a>
  </div>
  
</template>

<script>
export default {
  name: 'contactuser',
  props:{
    phone: String,
    email: String,
    name: String
  }
}
</script>

<style>
.contact-box {
  text-align: left;
  color: white;
  margin-top: 4px;
}

.contact-box a {
  color: white;
}

</style>